import axios from 'axios';

const BASE_URL = 'https://youtube138.p.rapidapi.com';

const options = {
	params: { hl: 'en', gl: 'US' },
	headers: {
		'X-RapidAPI-Key':
			process.env.YOUTUBE_API_KEY || '40c3d6c57amshad590a249ab8f97p166e8ajsn579516282775',
		'X-RapidAPI-Host': 'youtube138.p.rapidapi.com',
	},
};

export const fetchDataFromApi = async url => {
    console.log(process.env.YOUTUBE_API_KEY)
	const { data } = await axios.get(`${BASE_URL}/${url}`, options);
	return data;
};
